const { REACT_APP_API_URL } = process.env;
const HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

export const setOptions = (options) => {
  const altHeaders = options.token
    ? { Authorization: `Token ${options.token}` }
    : {};

  // Si los datos son FormData, no establecer Content-Type para que el navegador lo maneje automáticamente
  const isFormData = options.data instanceof FormData;
  const headers = isFormData
    ? { ...altHeaders } // Solo Authorization, sin Content-Type
    : { ...HEADERS, ...altHeaders }; // Headers normales con Content-Type: application/json

  return {
    headers,
    // Si no hay data, devolvemos undefined para que axios no envíe cuerpo por defecto
    params:
      options.data !== undefined
        ? isFormData
          ? options.data
          : { ...options.data }
        : undefined,
    url: `${(REACT_APP_API_URL || '').replace(/\/$/, '')}/${(
      options.url || ''
    ).replace(/^\//, '')}`,
  };
};
